type UserTokenProfileProps = {
    used: number;
    total: number;
    renewalDate?: Date;
};

export default class UserTokenProfile {
    used: number;

    total: number;

    renewalDate?: Date;

    constructor({ used, total, renewalDate }: UserTokenProfileProps) {
        this.used = used;
        this.total = total;
        this.renewalDate = renewalDate;
    }

    get usagePercent(): number {
        if (this.total === 0) return 0;

        return Math.round((this.used / this.total) * 100);
    }

    get isExhausted(): boolean {
        return this.total > 0 && this.used >= this.total;
    }
}
